"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidFolderFormatError = void 0;
class InvalidFolderFormatError extends Error {
    constructor(...args) {
        super(...args);
        this.code = 422;
        this.name = 'InvalidFolderFormat';
        Error.captureStackTrace(this, InvalidFolderFormatError);
    }
}
exports.InvalidFolderFormatError = InvalidFolderFormatError;
//# sourceMappingURL=invalid-folder-format-error.js.map